import { useEffect, useState } from 'react';
import {
    Button,
    Box,
    Stack,
    Typography,
    FormControl,
    TextField,
} from '@mui/material';
import { SelectAllFromTable } from '../universal/Axios';
import { SignalNoiseSeparationInputTable } from '../comparativeSets/SignalNoiseSeparationInputTable';
import apiClient from '../../apiClient';
import { getStore } from '../../Store'

const store = getStore();

const CreateComparativeSet = () => {
    const [existingComparativeSets, setExistingComparativeSets] = useState([])
    const [selectedSnsiIDs, selectSnsiID] = useState([])
    const [description, setDescription] = useState("")
    const [errorMessages, setErrorMessages] = useState([])
    const [id, setID] = useState("")

    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true)

    useEffect(() => {
        if (id && id !== "" && selectedSnsiIDs.length > 0) {
            setSubmitButtonDisabled(false)
        }
        else {
            setSubmitButtonDisabled(true)
        }
    }, [selectedSnsiIDs, id]);

    useEffect(() => {
        SelectAllFromTable('comparative_set', setExistingComparativeSets)
    }, [])

    useEffect(() => {
        if (id !== "" && id && id.length > 0 && selectedSnsiIDs.length > 0) {
            setSubmitButtonDisabled(false)
        }
        else {
            setSubmitButtonDisabled(true)
        }
    }, [id, selectedSnsiIDs]);

    const createComparativeSet = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Create_Comparative_Set",
                "id": id,
                "description": description,
                "snsi_id_list": selectedSnsiIDs,
            }
        ).then(() => {
            store.updateSuccessMessage("Successfully generated comparative set!")
            window.location.href = "/edit-comparative-set?id=" + id
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                //handleautherror(dispatch)
            } else {

            }
        });
    }

    return (
        <Box>
            <Typography variant="h5">Create Comparative Set</Typography>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '15%', marginTop: '25px', marginRight: '20px' }}>
                    <TextField
                        id="id"
                        label="Comparative Set ID"
                        onChange={(event) => setID(event.target.value)}
                        required
                        defaultValue={id}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: '83%', marginTop: '25px' }}>
                    <TextField
                        id="description"
                        label="Description"
                        onChange={(event) => setDescription(event.target.value)}
                        defaultValue={description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            <Box sx={{ height: errorMessages.length > 0 ? '20px' : '0px', color: "#eb9834", marginTop: '10px' }}>
                {errorMessages}
            </Box>
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button variant="outlined" href={"comparative-sets"}>Cancel</Button>
                    <Button variant="outlined" onClick={() => createComparativeSet()} disabled={isSubmitButtonDisabled}>Submit</Button>
                </Stack>
            </Box>
            <Box sx={{ m: 2, height: '800px', }}>
                <h3>
                    Signal Noise Separation Inputs
                </h3>
                <SignalNoiseSeparationInputTable comparativeSetID={null} selectSignalNoiseSeparationInput={selectSnsiID} selectedSignalNoiseSeparationInput={selectedSnsiIDs} selectionEnabled={true} />
            </Box>
        </Box>
    )
}

export default CreateComparativeSet;
